export default "__VITE_ASSET__9ffdd2de__"